import { useEffect, useRef } from 'react'
import { animate, useReducedMotion } from 'framer-motion'

/**
 * Número que "sube" hasta su valor cuando llega el dato. La animación ocurre
 * porque la cifra cambió (carga o actualización), no en bucle.
 */
export default function AnimatedNumber({ value, duration = 1.1, format = (n: number) => Math.round(n).toLocaleString('es-PE') }: {
  value: number | null
  duration?: number
  format?: (n: number) => string
}) {
  const ref = useRef<HTMLSpanElement>(null)
  const from = useRef(0)
  const reduce = useReducedMotion()

  useEffect(() => {
    if (value === null || !ref.current) return
    if (reduce) {
      ref.current.textContent = format(value)
      from.current = value
      return
    }
    const controls = animate(from.current, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: v => { if (ref.current) ref.current.textContent = format(v) },
    })
    from.current = value
    return () => controls.stop()
  }, [value, duration, format, reduce])

  return <span ref={ref}>{value === null ? '—' : format(0)}</span>
}
